import { ConfigService } from '@maia/config';
import { HttpService } from '@maia/httpClient';
import { AttachmentService } from '@maia/shared';
import { AttachmentController } from './attachments.controller';

export class AttachmentFactory {
  private readonly configService = new ConfigService();
  private readonly httpService = new HttpService(
    this.configService,
    'attachmentsUrl',
  );

  createAttachmentController(): AttachmentController {
    return new AttachmentController(this.createBrokerService());
  }

  private createBrokerService(): AttachmentService {
    return new AttachmentService(this.httpService, this.configService);
  }
}

const factory = new AttachmentFactory();
export const service = factory.createAttachmentController();
